// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3WqCG","log":"ModalInventoryLogs_log__1eocA","date":"ModalInventoryLogs_date__2_9qg","userName":"ModalInventoryLogs_userName__216fB"};